import { IEspSponsorInput, IEspSponsorOption } from '../../model/types'

/** The form's bit comes back as `true`/`false` or `1`/`0`, depending on the data provider. */
export const isEspSponsorActive = (sponsor: IEspSponsorOption): boolean =>
  sponsor.IsActive === true || Number(sponsor.IsActive) === 1

export const toEspSponsorInput = (sponsor: IEspSponsorOption | null): IEspSponsorInput => ({
  Name: sponsor?.Name ?? '',
  Title: sponsor?.Title ?? '',
  ExecutiveLevel: sponsor?.ExecutiveLevel ?? '',
  Location: sponsor?.Location ?? '',
  IsActive: sponsor ? isEspSponsorActive(sponsor) : true,
})
